import { DOORSTEP_DELIVERY_SERVICE_TYPE_ID } from '../server/constants.js';
export const getAllSelectedInstallationServices = (form) => {
    const allServices = getAllSelectedInstallationServiceIds(form);
    const allAccessories = getInstallationServiceAccessories(form);
    return allServices.map(productId => {
        const accessory = allAccessories.find(acc => acc.productId === productId);
        return {
            productId,
            accessoryId: accessory ? String(accessory.accessoryId) : undefined,
        };
    });
};
export const getAllSelectedInstallationServiceIds = (form) => {
    const mainServices = form.getAll('mainServices').map(String);
    const subServices = form.getAll('subServices').map(String);
    const individualMainServices = form.getAll('individualMainServices').map(String);
    return [...mainServices, ...subServices, ...individualMainServices];
};
export const getInstallationServiceAccessories = (form) => {
    const accessories = form.getAll('installationServiceAccessory').map(String); // e.g. ["123:456", "124:457"]
    return accessories.map(item => {
        const [productId, accessoryId] = item.split(':').map(String);
        return {
            productId,
            accessoryId,
        };
    });
};
export const isDoorstepDelivery = (serviceTypeId) => {
    return serviceTypeId === DOORSTEP_DELIVERY_SERVICE_TYPE_ID;
};
//# sourceMappingURL=Helpers.js.map